import ApiBase from './ApiBase';

const productSegmentsEndpoint = 'productsegments' as string;

class ProductSegmentsApi extends ApiBase {
    getProductSegments(): Promise<string[]> {
        return this.doHttpRequest<string[]>('get', `${productSegmentsEndpoint}`, null, false);
    }
}

export default new ProductSegmentsApi();